import { useEffect, useRef } from "react";

import { WavingHandIcon } from "./icons";

/**
 * Dialog shown when a returning voter (same RRN) already has a treesponse.
 * Offers two deliberate choices: resume the existing session, or review the
 * projects again from the start. Both write to the SAME treesponse line.
 *
 * Matches Figma node 6075-4714 ("Welkom terug!"). Not dismissable by
 * backdrop/Esc — the voter must pick one of the two options.
 */
export default function ResumeDialog({
  open,
  title,
  detail,
  continueLabel,
  restartLabel,
  onContinue,
  onRestart,
  busy,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) {
      dialog.showModal();
      window.fathom?.trackEvent("second login");
    } else if (!open && dialog.open) {
      dialog.close();
    }
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="resume-dialog"
      onCancel={(e) => e.preventDefault()}
    >
      <div className="resume-dialog__content">
        <div className="resume-dialog__heading">
          <WavingHandIcon className="resume-dialog__icon" />
          <h1 className="resume-dialog__title">{title}</h1>
          {detail && <p className="resume-dialog__detail">{detail}</p>}
        </div>
        <div className="resume-dialog__actions">
          <button
            type="button"
            className="button button--full-width"
            onClick={onContinue}
            disabled={busy}
          >
            {continueLabel}
          </button>
          <button
            type="button"
            className="button button--white button--full-width"
            onClick={onRestart}
            disabled={busy}
          >
            {restartLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
